import React from 'react'
import styled from 'styled-components'

import Wrapper from 'components/Wrapper'
import { H2, H4, lineHeights, fontWeights } from 'styles/typography'
import Button from 'components/button/Button'
import { white, borderColor } from 'styles/colors'
import Section, { SectionBlock } from 'components/Section'
import TierComparison from 'components/vype-plus/TierComparison'
import { NativeAuthConsumer } from 'components/NativeAuth'

const Heading = styled(H2)`
  color: ${white};
  margin-bottom: 0.4em;
`

const Subheading = styled(H4)`
  font-weight: ${fontWeights.regular};
  max-width: 740px;
  margin: 0 auto;
  color: ${borderColor};
  line-height: ${lineHeights.base};
`

const Benefits = () => (
  <Section id="benefits">
    <Wrapper>
      <SectionBlock className="u-text-center">
        <Heading>See what Vuse+ has to offer</Heading>
        <Subheading>
          Reaping the benefits as a member is easy. <br className="u-hide-small-down" />
          We guarantee you can’t get these vaping deals anywhere else.
        </Subheading>
      </SectionBlock>
      <SectionBlock>
        <TierComparison />
      </SectionBlock>
      <SectionBlock
        css={`
          text-align: center;
        `}
      >
        <NativeAuthConsumer>
          {({ user, setSignupModalVisibility }) => {
            return user ? (
              <Button to="/account/rewards/" theme="custom" customColor={white}>
                Find out your status
              </Button>
            ) : (
              <Button
                theme="custom"
                customColor={white}
                onClick={() => {
                  setSignupModalVisibility(true)
                }}
              >
                Find out your status
              </Button>
            )
          }}
        </NativeAuthConsumer>
      </SectionBlock>
    </Wrapper>
  </Section>
)

export default Benefits
